import type { ResponseJobResumeRequest, JobResumeResponse } from '../types/personShow';
import { wrapFetch, wrapFetchRequiringLogin } from '../libs/fetch';

export const requestJobResume = async (personId: number, csrfToken: string) => {
  return await wrapFetch<ResponseJobResumeRequest>(`/api/v1/job_resumes/${personId}/request_job_resume`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
  });
};

export const sendJobResumes = async (personId: number, file: File | string, csrfToken: string) => {
  const formData = new FormData();
  formData.append('file', file);
  return await wrapFetch<JobResumeResponse>(`/api/v1/job_resumes/${personId}`, {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': csrfToken,
    },
    body: formData,
    credentials: 'same-origin',
  });
};

export const fetchJobResume = async (personId: number) => {
  return await wrapFetchRequiringLogin<JobResumeResponse>(`/api/v1/job_resumes/${personId}`);
};
